import React from 'react';
import {translate} from "react-i18next";
import LogbookApi from "../../apis/LogbookApi";
import Select2 from "react-select2-wrapper";
import connect from "react-redux/es/connect/connect";
import {load} from "../../actions/logbookAction";

class AddInformation extends React.Component {

    state = {
        status: 'CREATED',
        assignee: null,
        message: '',
        loading: false,
        errors: {}
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({loading: true, errors: {}});
        LogbookApi.addEntry({
            type: 'TASK',
            message: this.state.message,
            status: this.state.status,
            assignee: this.state.assignee
        }).then((result) => {
            if (result.data.success === true) {
                this.props.handleClose();
            } else {
                this.setState({
                    errors: result.data.errors,
                    loading: false
                });
            }
        });
    };

    render() {
        const {t} = this.props;
        return (
            <div className="entry entry-new" key="entry-new">
                <form onSubmit={this.handleSubmit}>
                    <div
                        className={"form-group" + ((this.state.errors && this.state.errors.message) ? ' has-error' : '')}>
                        <label>
                            {t('logbook.entry.message')}
                        </label>
                        <textarea className="form-control" value={this.state.message}
                                  onChange={(e) => this.setState({message: e.target.value})}
                                  disabled={this.state.loading}/>
                        {(this.state.errors && this.state.errors.message) ? (
                            <span className="help-block">
                                                {t('logbook.message.error.' + this.state.errors.message)}
                            </span>
                        ) : null}
                    </div>
                    <div className="row">
                        <div className="col-xs-3">
                            <div
                                className={"form-group" + ((this.state.errors && this.state.errors.status) ? ' has-error' : '')}>
                                <label>
                                    {t('logbook.entry.status.title')}
                                </label>
                                <Select2 data={[
                                    {id: 'CREATED', text: t('default.task.status.created')},
                                    {id: 'IN_PROGRESS', text: t('default.task.status.inProgress')},
                                    {id: 'DONE', text: t('default.task.status.done')},
                                ]} value={this.state.status} onChange={(e) => this.setState({status: e.target.value})} name="status"
                                         disabled={this.state.loading}
                                         options={{placeholder: t('logbook.status.placeholder')}}
                                         className="width-100p block"/>
                                {(this.state.errors && this.state.errors.status) ? (
                                    <span className="help-block">
                                                {t('logbook.status.error.' + this.state.errors.status)}
                            </span>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-xs-3">
                            <div
                                className={"form-group" + ((this.state.errors && this.state.errors.assignee) ? ' has-error' : '')}>
                                <label>
                                    {t('logbook.entry.assignee.title')}
                                </label>
                                <Select2 data={this.props.logbook.availableAssignees.map((el) => {
                                    return {
                                        text: el.username, id: el.id
                                    }
                                })} value={this.state.assignee} onChange={(e) => this.setState({assignee: e.target.value})} name="assignee"
                                         disabled={this.state.loading}
                                         options={{placeholder: t('logbook.assignee.placeholder')}}
                                         className="width-100p block" onOpen={()=> {console.log('open');}} onClose={()=> {console.log('close')}}/>
                                {(this.state.errors && this.state.errors.assignee) ? (
                                    <span className="help-block">
                                                {t('logbook.assignee.error.' + this.state.errors.assignee)}
                            </span>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-xs-2">
                        </div>
                        <div className="col-xs-4 text-right form-group">
                            <label className="block">&nbsp;</label>
                            <button type="submit" className="btn btn-sm btn-primary" disabled={this.state.loading}>
                                <i className={`fa fa-${this.state.loading ? 'spin fa-spinner' : 'save'} m-r-xs`}/> {t('default.save')}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    logbook: state.logbook
});

export default connect(mapStateToProps, {
})(translate()(AddInformation));
